// TODO: currying
var preventDefault = function preventDefault(cb) {
  return function (event) {
    if (event.preventDefault) {
      event.preventDefault();
    }

    cb(event);
  };
};

export default preventDefault;